import React from 'react';
import { CopilotProvider } from './CopilotContext';
import { CopilotLauncher } from './CopilotLauncher';
import { CopilotPanel } from './CopilotPanel';
import { CommandPalette } from './CommandPalette';

/**
 * Mounts the entire in-app Copilot: the floating launcher, the slide-over chat
 * panel, and the ⌘K command palette — all sharing one provider. Drop this once
 * inside the authenticated app shell (must be inside the Router).
 */
export function Copilot() {
  return (
    <CopilotProvider>
      <CopilotLauncher />
      <CopilotPanel />
      <CommandPalette />
    </CopilotProvider>
  );
}
